import { styled } from '@mui/joy';

import { HEADER_HEIGHT } from 'theme/constants';

import { NOTIFICATION_ALERT_WIDTH } from '../NotificationAlert';

const TOAST_STACK_OFFSET_TOP = 14;
const TOAST_STACK_OFFSET_RIGHT = 24;
const TOAST_STACK_OFFSET_BOTTOM = 16;

export const TOAST_STACK_MAX_HEIGHT = `calc(100vh - ${
  HEADER_HEIGHT + TOAST_STACK_OFFSET_TOP + TOAST_STACK_OFFSET_BOTTOM
}px)`;

// The region box never blocks the page: only the stack inside takes the pointer.
export const ToastStackRoot = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: HEADER_HEIGHT + TOAST_STACK_OFFSET_TOP,
  right: TOAST_STACK_OFFSET_RIGHT,
  zIndex: theme.vars.zIndex.snackbar,
  width: NOTIFICATION_ALERT_WIDTH,
  maxWidth: `calc(100vw - ${2 * TOAST_STACK_OFFSET_RIGHT}px)`,
  pointerEvents: 'none',
}));
